import { render, staticRenderFns } from "./registerdevice.vue?vue&type=template&id=7cf6f06a&"
import script from "./registerdevice.vue?vue&type=script&lang=js&"
export * from "./registerdevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports